export const ICON_GAP_TRANSITION = '0.3s ease';
